import { OdataKeyConfigs } from '@common/models';

export function prepareParamsToString(queryParams: OdataKeyConfigs): string {
  return Object.entries(queryParams)
    .map(([key, value]) => `${encodeURI(key)}=${encodeURIComponent(String(value))}`)
    .join('&');
}
